import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-call.js";
import "../internals/new-promise-capability.js";
import { p as i } from "../internals/promise-constructor-detection.js";
import { __exports as o } from "../../../_virtual/new-promise-capability.js";
r({
  target: "Promise",
  stat: !0,
  forced: i.CONSTRUCTOR
}, {
  reject: function reject(r) {
    var i = o.f(this);
    return t(i.reject, void 0, r), i.promise;
  }
});